import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectTaskTypeDynamicField = createSelector(
  getSystem,
  ({ taskTypeDynamicField }) => taskTypeDynamicField,
);
